import { disableBodyScroll, enableBodyScroll } from '../modules/bodyScrollLock.es6';

function Smoothscroll(onscroll) {//return;
    const isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    const el = document.querySelector('.smoothScroll');
    const content = el.querySelector('.smoothScroll-content');
    let current = 0;
    let last = 0;
    let rounded = 0;
    let ease = .055;
    let myReq;
    const footer = document.querySelector('#footer')

    function animation(param) {
        let req;
        let init = null;
        let time;

        const start = param.start;
        const end = param.end;
        const duration = 1500;

        const easing = (t, b, c, d) => (t /= d / 2) < 1 ? c / 2 * t * t * t * t + b : -c / 2 * ((t -= 2) * t * t * t - 2) + b;

        const startAnim = timeStamp => {
            init = timeStamp;
            draw(timeStamp);
        }

        const draw = now => {
            time = now - init;
            param.onChange(easing(time, start, end - start, duration));
            req = window.requestAnimationFrame(draw);
            time >= duration && window.cancelAnimationFrame(req)
        }

        req = window.requestAnimationFrame(startAnim)
    }

    const scroll = () => current = window.pageYOffset;

    const run = () => {
        last += (current - last) * ease;
        rounded = Math.round(last * 100) / 100;
        content.style.transform = `matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ${-rounded}, 0, 1)`;
        this.onscroll(rounded);

        myReq = requestAnimationFrame(run);
    }

    const onresize = () => {
        if (!isTouch) document.body.style.height = `${content.clientHeight}px`;
        scroll();
    }

    this.popo = () => { 
        onresize();
    }

    this.onscroll = () => { };

    this.scrollTo = (val) => {
        animation({
            start: window.pageYOffset,
            end: val,
            onChange(value) {
                window.scrollTo(0, value);
            }
        });
    };

    this.goTo = val => {
        cancelAnimationFrame(myReq);
        ease = 1;
        rounded = Math.round(val * 100) / 100;
        last = rounded;
        window.scrollTo(0, rounded);
        if (!isTouch) {
            content.style.transform = `translateY(${rounded}px)`;
            myReq = requestAnimationFrame(run);
        }
        setTimeout(() => {
            ease = .095;
        }, 300)
    };

    this.disabled = () => {
        disableBodyScroll(document.body);
        cancelAnimationFrame(myReq);
    }

    this.enabled = () => {
        enableBodyScroll(document.body);
        if (!isTouch) myReq = requestAnimationFrame(run);
    }

    this.toTop = () => {
        cancelAnimationFrame(myReq);
        content.style.transform = `translateY(0)`;
        window.scrollTo(0, 0);
    };

    this.reset = () => {
        current = 0;
        last = 0;
        onresize();
        cancelAnimationFrame(myReq);
        if (!isTouch) myReq = requestAnimationFrame(run);
    }

    this.resize = (val) => {
        current = val;
        last = val;
        cancelAnimationFrame(myReq);
        onresize();
        window.scrollTo(0, val);
        if (!isTouch) myReq = requestAnimationFrame(run);
    }

    if (!isTouch) {
        window.addEventListener('resize', onresize, { passive: true })
        window.addEventListener('scroll', scroll, { passive: true })

        onresize();

        myReq = requestAnimationFrame(run);

        Object.assign(el.style, {
            position: 'fixed',
            height: '100%',
            width: '100%'
        })
    }
    else {
        window.addEventListener('scroll', () => this.onscroll(window.pageYOffset), { passive: true })
    }
}



export default Smoothscroll;